import React from "react";
import { motion } from "motion/react";
import { MessageSquare } from "lucide-react";
import ProgressBar from "../ui/ProgressBar";

export default function ExpertClientsTab({
  selectedClientForGoals,
  setSelectedClientForGoals,
  uniqueClients,
  expertBookings,
  expertId,
  profileName
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <h2 className="text-2xl font-medium text-white">Мои клиенты</h2>

      {selectedClientForGoals ? (
        <div className="space-y-6">
          <button
            onClick={() => setSelectedClientForGoals(null)}
            className="flex items-center gap-2 text-neutral-400 hover:text-white transition-colors"
          >
            <span className="text-lg font-extralight">← Назад к клиентам</span>
          </button>
          <ProgressBar
            expertId={expertId}
            clientId={selectedClientForGoals.id}
            expertName={profileName}
            isExpertView={true}
          />
        </div>
      ) : uniqueClients.length === 0 ? (
        <div className="p-6 rounded-2xl bg-neutral-900 border border-neutral-800 text-center py-12">
          <MessageSquare className="w-10 h-10 text-neutral-700 mx-auto mb-3" />
          <p className="text-lg font-extralight text-neutral-500">
            Пока нет клиентов
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {uniqueClients.map((client) => {
            const clientBookings = expertBookings.filter((b) => b.clientId === client.id);
            const completedCount = clientBookings.filter((b) => b.status === "completed").length;
            return (
              <div
                key={client.id}
                className="p-5 rounded-md bg-neutral-900 border border-neutral-800"
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center">
                    <span className="text-white text-lg font-medium">{client.name[0]}</span>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-medium text-white">{client.name}</h4>
                    <p className="text-lg font-extralight text-neutral-400">
                      {completedCount} консультаций проведено
                    </p>
                  </div>
                  <button
                    onClick={() => setSelectedClientForGoals(client)}
                    className="flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500/10 text-primary-400 hover:bg-primary-500/20 transition-colors"
                  >
                    <span className="text-lg font-extralight">Цели и прогресс</span>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </motion.div>
  );
}
